import React, { useEffect, useState } from 'react'
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded'
import StopCircleRoundedIcon from '@mui/icons-material/StopCircleRounded'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded'
import ModeCommentRoundedIcon from '@mui/icons-material/ModeCommentRounded'
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded'
import VolumeOffRoundedIcon from '@mui/icons-material/VolumeOffRounded'
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent'
import { FEEDBACK_BOT, MATCH_BOT, SEQUENCE_BOT, TUTOR_BOT } from '../constants'
import { Button } from 'carbon-components-react'
import { ArrowRight } from '@carbon/icons-react'
const BotAssistSettings = (props) => {
  const {
    isBgAudioPlayed,
    audioUrl,
    text,
    botType,
    tutorialStart,
    ttsPlayType,
    onFrwdSkipClick,
    isAudioForcedStopped,
    isReplayHappening,
    onHideSubtitle,
    knovoHelpClick,
    displayWlakthrough,
    tutorTalking,
    onReadmoreClick,
    isAiChatBotVisible,
    completedAllCompData,
    isMinimize,
    headerItem,
    isExtraPractice
  } = props
  const { onBotStopped, onBotComplete, getTutorTalking, onSkipClick } = props
  const [isBotMute, setIsBotMute] = useState(false)
  const [isMuteClick, setIsMuteClick] = useState(false)
  const [isHideSubtitle, setIsHideSubtitle] = useState(false)
  const [showCC, setShowCC] = useState(false)
  const [readmoreClick, setReadmoreClick] = useState(false)
  const [audio, setAudio] = useState(undefined)
  const [isAudioPlaying, setIsAudioPlaying] = useState(false)
  const [isAudioMuted, setIsAudioMuted] = useState(false)
  const [isAudioStopped, setIsAudioStopped] = useState(false)

  // Handle line-by-line playback
  useEffect(() => {
    if (audioUrl && audioUrl !== '' && tutorialStart) {
      let audio = new Audio(audioUrl)
      audio.play()
      audio
        .play()
        .then(() => {
          setIsAudioPlaying(true)
        })
        .catch((error) => {
          console.error('Audio play failed:', error)
          handleAudioError(error) // Call a fallback function
        })

      audio.addEventListener('ended', () => {
        setIsAudioPlaying(false)
        onBotComplete()
      })
      audio.removeEventListener('ended', () => {
        setIsAudioPlaying(false)
        onBotComplete()
      })
      setAudio(audio)
    } else {
      console.log('No audio to play')
    }
  }, [audioUrl, tutorialStart])

  // Function to handle audio errors
  function handleAudioError(error) {
    if (error.name === 'NotSupportedError') {
      setIsAudioStopped(true)
      setIsAudioPlaying(false)
      onBotStopped()
      setAudio(undefined)
      console.log('Audio format not supported. Trying fallback...')
      // You can either try another audio format or notify the user
    } else if (error.name === 'AbortError') {
      setIsAudioStopped(true)
      setIsAudioPlaying(false)
      onBotStopped()
      setAudio(undefined)
      console.log('Audio playback was aborted.')
    } else {
      setIsAudioStopped(true)
      setIsAudioPlaying(false)
      onBotStopped()
      setAudio(undefined)
      console.log('Unknown error occurred:', error)
    }
  }

  useEffect(() => {
    if (isAudioPlaying) {
      getTutorTalking(false)
    } else {
      getTutorTalking(true)
    }
  }, [isAudioPlaying])

  useEffect(() => {
    if (isAudioForcedStopped) {
      forcestopedAudio()
    }
  }, [isAudioForcedStopped])

  //Stop audio is playing
  function forcestopedAudio() {
    if (audio) {
      audio.pause()
      setIsAudioStopped(true)
      setIsAudioPlaying(false)
      onBotStopped()
      setAudio(undefined)
    }
  }

  //Stop audio is playing
  function stopAudio() {
    if (audio) {
      audio.pause()
      setIsAudioStopped(true)
      setIsAudioPlaying(false)
      onBotStopped()
    }
  }

  function playAudio() {
    if (audio) {
      audio.play()
      setIsAudioStopped(false)
      setIsAudioPlaying(true)
    }
  }

  //Resume audio
  function resumeAudio() {
    if (audio) {
      audio.resume()
      setIsAudioStopped(false)
      setIsAudioPlaying(true)
    }
  }

  useEffect(() => {
    if (isMuteClick) {
      setIsMuteClick(false)
    }
  }, [isMuteClick])

  useEffect(() => {
    if (onHideSubtitle) {
      onHideSubtitle(isHideSubtitle)
    }
  }, [isHideSubtitle])

  useEffect(() => {
    if (knovoHelpClick) {
      setIsHideSubtitle(true)
    }
  }, [knovoHelpClick])

  useEffect(() => {
    if (readmoreClick) {
      onReadmoreClick(readmoreClick)
      setTimeout(() => {
        setReadmoreClick(false)
      }, 2000)
    }
  }, [readmoreClick])

  useEffect(() => {
    if (Array.isArray(text)) {
      if (text[0] === '') {
        setShowCC(false)
      } else {
        setShowCC(true)
      }
    } else {
      if (text === '') {
        setShowCC(false)
      } else {
        setShowCC(true)
      }
    }
  }, [text])

  useEffect(() => {
    if (ttsPlayType === 'sequence') {
      var objDiv = document.getElementById('subtSeqDiv')
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight
      }
    }
  }, [completedAllCompData])

  function renderButtonSettings(buttonType) {
    return (
      <div className='button-container-main'>
        <div
          className='bot-handle-icon-div'
          onClick={() => {
            if (audio) {
              if (isAudioPlaying) {
                stopAudio()
              } else {
                playAudio()
              }
            }
          }}
        >
          <span>
            {isAudioPlaying ? (
              <StopCircleRoundedIcon
                style={{
                  width: '35px',
                  height: '35px',
                  color: '#6644ff',
                  cursor: 'pointer'
                }}
              />
            ) : (
              <PlayCircleRoundedIcon
                style={{
                  width: '35px',
                  height: '35px',
                  color: '#6644ff',
                  cursor: 'pointer'
                }}
              />
            )}
          </span>
        </div>
        <div
          className='bot-handle-icon-div'
          onClick={() => {
            setReadmoreClick(false)
            setIsMuteClick(true)
          }}
        >
          {isAudioMuted ? (
            <VolumeOffRoundedIcon
              style={{
                width: '25px',
                height: '25px',
                color: '#6644ff',
                cursor: 'pointer'
              }}
            />
          ) : (
            <VolumeUpRoundedIcon
              style={{
                width: '25px',
                height: '25px',
                color: '#6644ff',
                cursor: 'pointer'
              }}
            />
          )}
        </div>
        <div
          className='bot-handle-icon-div'
          onClick={() => {
            if (botType === TUTOR_BOT) {
              stopAudio()
              onBotComplete()
            } else {
              onFrwdSkipClick()
            }
          }}
        >
          <div className='arrow-skip-circle'>
            <ArrowForwardIosRoundedIcon
              style={{
                width: '20px',
                height: '20px',
                color: '#ffffff'
              }}
            />
          </div>
        </div>

        <div
          className='bot-handle-icon-div'
          onClick={() => {
            setIsHideSubtitle(true)
          }}
        >
          <RemoveCircleRoundedIcon
            style={{
              width: '35px',
              height: '35px',
              color: '#ffc42d'
            }}
          />
        </div>
      </div>
    )
  }

  function renderSubtitlesText() {
    if (botType === MATCH_BOT) {
      return (
        <div className='knovo-help-container' style={{ zIndex: 25 }}>
          <div className='knovo-help-heading'>
            <p className='knovo-help-lebel1'> Your word is:</p>
          </div>
          <div className='smart-label-hint-container'>
            <span className='smart-label-hint-text'>{headerItem}</span>
            <Button
              className='smart-label-skip-icon'
              hasIconOnly
              iconDescription='Skip'
              renderIcon={ArrowRight}
              tooltipAlignment='center'
              tooltipPosition='bottom'
              onClick={() => {
                onSkipClick()
              }}
            />
          </div>
        </div>
      )
    } else {
      return (
        <div
          className='subtitleContainer'
          style={{
            right: isExtraPractice
              ? '75px'
              : isAudioPlaying
              ? isMinimize
                ? '200px'
                : '150px'
              : isMinimize
              ? '150px'
              : '120px',
            bottom: isExtraPractice ? '15%' : '20%'
          }}
        >
          <div
            className='subtitleLabelContainer'
            style={{
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '300px',
              overflow: 'auto',
              justifyContent: 'flex-start'
            }}
          >
            {Array.isArray(text) ? (
              text.map((subText) => {
                if (subText !== '') {
                  return <p className='subtitleLabel'>{subText}</p>
                }
              })
            ) : (
              <p className='subtitleLabel'>{text}</p>
            )}
          </div>
          {botType !== FEEDBACK_BOT && (
            <div className='subtitleButtonContainer'>
              {renderButtonSettings(botType)}
            </div>
          )}
        </div>
      )
    }
  }

  if (displayWlakthrough || isAiChatBotVisible) {
    return null
  } else {
    if (isHideSubtitle || isReplayHappening) {
      return (
        <div
          className='hideSubtitleContainer'
          style={{
            right: isExtraPractice
              ? isAudioPlaying
                ? '150px'
                : '100px'
              : tutorTalking
              ? '180px'
              : '150px',
            bottom: tutorTalking ? '25%' : '20%'
          }}
          onClick={() => {
            if (!isReplayHappening) {
              setIsHideSubtitle(false)
            }
          }}
        >
          <ModeCommentRoundedIcon
            style={{ width: '25px', height: '25px', color: '#ffffff' }}
          />
        </div>
      )
    } else {
      return <span>{renderSubtitlesText()}</span>
    }
  }
}
export { BotAssistSettings }
